export enum CommentStateEnum {
  PUBLIC = "public",
  STUDIO_REJECTED = "studioRejected",
  STUDIO_ACCEPTED = "studioAccepted"
}

export interface CommentType {
  id: string;
  createdAt: string;
  ownerId: string;
  submissionId: string;
  body: string;
  state: CommentStateEnum;
}

export interface CommentExtendedType extends CommentType {
  delete: Function;
  edit: Function;
}
